/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateClientPaymentMethod } from "../redux/Slices/leadOfferSlice";
import appInsights from "../AppInsights";
import { useLocation } from "react-router-dom";

const PaymentMethodSuccess = () => {
  const dispatch = useDispatch();
  // const { session_id } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const session_id = params.get("session_id");

  // const [sessionId, setSessionId] = useState(
  //   localStorage.getItem("checkoutSessionId") || ""
  // );
  // const [leadOfferDetailsId] = useState(
  //   localStorage.getItem("payment_LeadOfferDetailsId") || ""
  // );

  const { loading, error } = useSelector(
    (state) => state.leadOffer
  );

  
  // Update sessionId if checkoutSession changes
  // useEffect(() => {
  //   if (checkoutSession?.id) {
  //     setSessionId(checkoutSession.id);
  //   }
  // }, [checkoutSession]);

  // Process payment method when sessionId is available
  useEffect(() => {
    if (session_id) {
          dispatch(updateClientPaymentMethod({ sessionId: session_id }))
            .unwrap()
            .then((data) => {
              console.log("UpdatePaymentMethod success:", data);
              appInsights.trackEvent({
                name: "ClientUpdatePaymentMethodSuccess",
                properties: {
                  eventType: "background_api",
                  status: "success",
                  userType: "client",
                  session_id,
                  timestamp: new Date().toISOString(),
                  action: "UpdatePaymentMethod",
                },
              });
            })
            .catch((apiError) => {
              console.error("UpdatePaymentMethod API call failed:", apiError);

              appInsights.trackException({
                exception: apiError,
                severityLevel: 2,
                properties: {
                  eventType: "background_api",
                  status: "failed",
                  userType: "client",
                  session_id,
                  timestamp: new Date().toISOString(),
                  action: "UpdatePaymentMethod",
                },
              });
            });
          }
  }, [dispatch, session_id]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-blue-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2>Processing your payment method...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-red-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2 className="text-red-500">Error Saving Card Details</h2>
          <p className="text-red-500">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-green-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-green-600 mb-4">
          Card Details Saved Successfully!
        </h2>
        <p className="text-gray-700">
          Your card details have been securely saved for future transactions.
          <br />
          Thank you for updating your payment information.
        </p>
      </div>
    </div>
  );
};

export default PaymentMethodSuccess;
